import React, { useState, useEffect } from "react";
import {
  AppBar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { observer } from "mobx-react-lite";
import { useController } from "../../assets/components/BaseContrroler";
import { Link } from "react-router-dom";

var logo = require("../../assets/images/logo1.png");

function Navbar() {
  const {
    baseController: { homeController },
  } = useController();
  const { setUrl, ScrollIntoViewHandle } = homeController;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // change threshold as needed
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { name: "Home", action: () => ScrollIntoViewHandle("home") },
    { name: "About Us", action: () => ScrollIntoViewHandle("about") },
    { name: "Services", action: () => ScrollIntoViewHandle("service") },
    { name: "Contact", action: () => setUrl("contact") },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        <img src={logo} alt="karnafully" width={60} />
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={item.action}
              component={Link}
              to="/"
            >
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton sx={{ textAlign: "center" }}>
            <LocalPhoneIcon style={{ color: "#ff5001" }} /> +8801732850650
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          transition: "0.3s",
          backgroundColor: scrolled ? "#fff" : "transparent",
        }}
      >
        <Toolbar>
          {/* Mobile menu button */}
          <IconButton
            color={scrolled ? "inherit" : "default"}
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Logo */}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
          >
            <img src={logo} alt="karnafully" width={60} />
          </Typography>

          {/* Desktop menu */}
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {navItems.map((item) => (
              <Button
                key={item.name}
                className="fw-bolder navItem-col-blue"
                onClick={item.action}
              >
                {item.name}
              </Button>
            ))}
            <Button className="nonCap navItem-col-blue">
              <LocalPhoneIcon style={{ color: "#ff5001" }} /> +8801732850650
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
        }}
      >
        {drawer}
      </Drawer>
    </Box>
  );
}

export default observer(Navbar);
